import React from 'react';
import CascadingCombo from '../../../additional/CascadingCombo';

export const getAdditionalItemsSection = (props) => {
  const {
    isDisabled,
    CascadingComboValue, setCascadingComboValue,
  } = props;

  return [
    // AdditionalItems section starts ...
    {
      id: "CascadingCombo", component: <CascadingCombo
        disabled={isDisabled} label = 'item' value={CascadingComboValue}
        onChange={(newValue) => { setCascadingComboValue(newValue); }}
      />,  // ✅ Render your component inside the expandable panel
      position: [1, 1], status: "active", expandableSectionId: "AdditionalItems"
    },
    // Additional Items ends ...
  ];
};
